/**
 * Extracts Gen2 input button types from settings for Scene conditions.
 * Returns an array of input types (one per physical input: SW1, SW2, …).
 * @param settings - Device settings (may have input:0, input:1, …)
 * @param _type - Device type (unused; kept for call-site compatibility)
 * @param channel - Fallback channel when settings is empty or no inputs found
 */
export const extract_gen_2_input_types = (
	settings: Record<string, { type?: string }> | undefined,
	_type: string | undefined,
	channel: number,
): (string | undefined)[] => {
	if (!settings) {
		return [settings?.[`input:${channel}`]?.type];
	}
	const inputTypes: (string | undefined)[] = [];
	let idx = 0;
	while (settings[`input:${idx}`] !== undefined) {
		inputTypes.push(settings[`input:${idx}`]?.type);
		idx++;
	}
	return inputTypes.length > 0 ? inputTypes : [settings[`input:${channel}`]?.type];
};
